/**
 * 封装了微信jssdk的一些方法
 */
export default class WxApi {
  /**
   * 小程序创建分享链接的页面
   * 可接收的参数：folderId 或 fileId
   */
  static get PAGE_SHARE_CREATE () {
    return 'shareCreate'
  }

  /**
   * 小程序主页，是个tab页
   */
  static get PAGE_HOME () {
    return 'home'
  }

  /**
   * 小程序文件主页，是个tab页
   */
  static get PAGE_MY_DOCUMENT () {
    return 'myDocument'
  }

  /**
   * 小程序单个分享链接的查看页面
   */
  static get PAGE_SHARE_DETAILS () {
    return 'shareDetails'
  }

  /**
   * 跳转到小程序指定页面，如果要跳转到tab页面，使用switchTab
   * @param {String} url
   * @param {Object} query
   */
  static navigateTo (url, query) {
    let wx = window.wx
    let suffix = ''
    if (query) {
      let index = 0
      for (let key in query) {
        if (query[key]) {
          if (index === 0) {
            suffix += '?'
          } else {
            suffix += '&'
          }
          suffix += (key + '=' + query[key])
          index++
        }
      }
    }
    wx.miniProgram.navigateTo({
      url: url + suffix
    })
  }

  /**
   * 跳转到 小程序tabBar 页面，并关闭其他所有非 tabBar 页面
   * @param {String} url
   */
  static switchTab (url) {
    let wx = window.wx
    wx.miniProgram.switchTab({
      url: url
    })
  }

  /**
   * 向小程序发送消息，会在特定时机（小程序后退、组件销毁、分享）触发组件的message事件
   * @param {String} msg
   */
  static postMsg (msg) {
    let wx = window.wx
    wx.miniProgram.postMessage({ data: msg })
  }
}
